import axios from 'axios';
import api from './api';
import { ReciboSearchFilters, ReciboCreateData, ReciboBatchCreateData, ReciboCancelData } from '../types/recibo';

const loadPrintWindow = (printWindow: Window, blob: Blob) => {
  if (printWindow.closed) throw new Error('La ventana de impresión fue cerrada');
  const url = window.URL.createObjectURL(blob);
  printWindow.addEventListener('load', () => window.URL.revokeObjectURL(url), { once: true });
  printWindow.location.replace(url);
};

const reciboService = {
  reservePrintWindow: () => {
    const printWindow = window.open('about:blank', '_blank');
    if (printWindow) {
      printWindow.opener = null;
      printWindow.document.write('<!DOCTYPE html><html lang="es"><meta charset="UTF-8"><title>Preparando recibos</title><body><p>Preparando recibos para imprimir…</p></body></html>');
      printWindow.document.close();
    }
    return printWindow;
  },

  printRecibos: async (ids: number[], printWindow: Window) => {
    const response = await axios.post(`${api.defaults.baseURL}/recibos/print`, { ids }, {
      responseType: 'blob',
      withCredentials: true,
    });
    if (!response.headers['content-type']?.includes('text/html')) {
      throw new Error('Respuesta de impresión inválida');
    }
    loadPrintWindow(printWindow, response.data);
  },

  /**
   * Search/list receipts with filters
   */
  searchRecibos: (filters: ReciboSearchFilters) => api.get('/recibos', { params: filters }),

  /**
   * Get receipt by ID
   */
  getReciboById: (id: number) => api.get(`/recibos/${id}`),

  updateTenantResguardo: (id: number, confirmado: boolean, numero: string) =>
    api.put(`/recibos/${id}/resguardo`, { resguardo_confirmado: confirmado, resguardo_numero: numero }),

  /**
   * Create new receipt (for partial payments)
   */
  createRecibo: (data: ReciboCreateData) => api.post('/recibos', data),

  /**
   * Create batch owner receipts (one per propietario for co-ownership properties)
   */
  createReciboBatch: (data: ReciboBatchCreateData) => api.post('/recibos/batch', data),

  /**
   * Cancel receipt
   */
  cancelRecibo: (id: number, data: ReciboCancelData) => api.put(`/recibos/${id}/cancel`, data),

  /**
   * Download receipt PDF or open print dialog
   */
  downloadReciboPDF: async (id: number) => {
    const printWindow = reciboService.reservePrintWindow();
    try {
      const baseURL = api.defaults.baseURL || 'http://localhost/backend';
      const response = await axios.get(`${baseURL}/recibos/${id}/pdf`, {
        responseType: 'blob',
        withCredentials: true,
      });
      if (response.headers['content-type']?.includes('text/html')) {
        if (!printWindow) throw new Error('Permita las ventanas emergentes para imprimir');
        loadPrintWindow(printWindow, response.data);
        return null;
      }
      printWindow?.close();
      return response.data;
    } catch (error) {
      printWindow?.close();
      throw error;
    }
  },

  /**
   * Get receipts for a specific contract
   */
  getRecibosByContrato: (contratoId: number) => api.get(`/contratos/${contratoId}/recibos`),

  /**
   * Get receipts for a specific payment
   */
  getRecibosByPago: (pagoId: number) => api.get(`/pagos/${pagoId}/recibos`),
};

export default reciboService;
